import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/components/layout/AuthProvider'

interface Props {
  children: React.ReactNode
  redirectTo?: string
}

// Redirects unauthenticated users to login, preserving where they wanted to go
export function RequireAuth({ children, redirectTo = '/auth/login' }: Props) {
  const { supabaseUser, initialized, loading } = useAuth()
  const location = useLocation()

  // While auth is initialising, render nothing (avoids flash redirect)
  if (!initialized || loading) {
    return (
      <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
        <svg className="w-8 h-8 animate-spin" viewBox="0 0 24 24" fill="none" style={{ color: '#ff4500' }}>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity=".25" />
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </div>
    )
  }

  if (!supabaseUser) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  return <>{children}</>
}
